// extracted by mini-css-extract-plugin
export default {"ellipsis":"ellipsisTooltip_ellipsis__aY7bS"};